import {Injectable} from '@angular/core';
import {LoginInfo} from '../models';

const _loginUserDataKey = 'loginUserData';
const _partnerDetailKey = 'partnerDetail';
const _currentPageDataKey = 'currentPageData';
const _studentIdKey = 'studentId';
const _studentLocalIdKey = 'studentLocalId';
const _parentStudentIdKey = 'parentStudentId';
const _parentChildLocalData = 'parentChildLocalData';
const _partnerIdKey = 'partnerIdForMessageAndCoaching';
const _classYearDescription = 'classYearDescription';
const _navigation = 'navigation';
const _selectedIndex = 'selectedIndex';
const _collegeIdData = 'collegeIdData';
const _forStudentId = 'forStudentId';
const _collegeSearchPath = 'collegeSearchPath';
const _routeArray = 'routeArray';
const _essayData = 'essayData';
const _envisionEntities = 'envisionEntities';
const _assignmentData = 'assignmentData';
const _bsDraggableModalsTray = 'bs-draggable-modals-tray';
const _searchResult = 'searchResult';
const _genderIdValue = 'genderIdValue';
const _selectedStudentParentId = 'selectedStudentParentId';
@Injectable()
export class LoginInfoProvider {
  private _loginInfo: Partial<LoginInfo>;
  // fixme: type is must
  private _partnerData;

  clearLoginInfo() {
    localStorage.removeItem(_loginUserDataKey);
   // localStorage.removeItem(_partnerDetailKey);
    localStorage.removeItem(_classYearDescription);
    localStorage.removeItem(_forStudentId);
    localStorage.removeItem(_currentPageDataKey);
    localStorage.removeItem(_collegeSearchPath);
    localStorage.removeItem(_studentIdKey);
    localStorage.removeItem(_studentLocalIdKey);
    localStorage.removeItem(_parentChildLocalData);
    localStorage.removeItem(_parentStudentIdKey);
    localStorage.removeItem(_partnerIdKey);
    localStorage.removeItem(_navigation);
    localStorage.removeItem(_selectedIndex);
    localStorage.removeItem(_collegeIdData);
    localStorage.removeItem(_routeArray);
    localStorage.removeItem(_essayData);
    localStorage.removeItem(_envisionEntities);
    localStorage.removeItem(_assignmentData);
    localStorage.removeItem(_bsDraggableModalsTray);
    localStorage.removeItem(_searchResult);
    localStorage.removeItem(_genderIdValue);
    localStorage.removeItem(_selectedStudentParentId);
    localStorage.removeItem('collegeData');
    localStorage.removeItem('careerCode');
    localStorage.removeItem('studentHideAssessment');
    localStorage.removeItem('studentRouteData');
    localStorage.removeItem('showMinuteVideo');
    
    this._loginInfo = null;
    this._partnerData = null;
  }

  private _getObjFromStorage<T>(key: string, def?: T): T {
    const _loginUserData = localStorage.getItem(key);
    if (!_loginUserData) {
      return def;
    }

    try {
      return JSON.parse(_loginUserData);
    } catch (e) {
      console.error(`LoginInfoProvider: failed to parse local storage value (${key})`, _loginUserData);
      return def;
    }
  }

  get loginInfo(): Partial<LoginInfo> {
    if (!this._loginInfo) {
      this._loginInfo = this._getObjFromStorage<Partial<LoginInfo>>(_loginUserDataKey, {})
    }

    return this._loginInfo;
  }

  set loginInfo(loginData: Partial<LoginInfo>) {
    this._loginInfo = loginData;
    localStorage.setItem(_loginUserDataKey, JSON.stringify(loginData));
  }

  get token(): string {
    return this.loginInfo.token;
  }

  get module(): string {
    const _module = this.loginInfo.module;
    return _module ? _module.trim().toLowerCase() : '';
  }

  get partnerId(): string {
    const partnerDetail = this._getObjFromStorage<any>(_partnerDetailKey, {});
    return this._loginInfo.partnerId;
  }

  // fixme: data type
  get parnerDetailData() {
    if (!this._partnerData) {
      this._partnerData = this._getObjFromStorage<any>(_partnerDetailKey, {});
    }

    return this._partnerData;
  }

  // JDO - 1.9.2018: These partnerDetail calls were probably better off in the PartnerDetailService (common concern). Will review again to validate.
  set partnerDetailData(data) {
    this._partnerData = data;
    localStorage.setItem(_partnerDetailKey, JSON.stringify(data));
  }

  get profileId() {
    return this.loginInfo.profileId;
  }

  get roleName() {
    return this.loginInfo.role;
  }

  get userFullName() {
    return `${this.loginInfo.firstName}  ${this.loginInfo.lastName}`;
  }

  get userId() {
    return this.loginInfo.userId;
  }

  get isSenior(): boolean {
    if (this.loginInfo.classYearDescription) {
      return this.loginInfo.classYearDescription.toLowerCase() === 'senior';
    }

  }
}
